import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const square = defineConnector({
  identifier: "square",
  name: "Square",
  tagLine: "Payments and commerce platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://connect\\.squareup\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Select your environment",
      items: [
        {
          kind: "select",
          label: "Environment",
          required: true,
          target: { kind: "configuration", field: "environment" },
          options: [
            { value: "production", label: "Production" },
            { value: "sandbox", label: "Sandbox" },
          ],
          defaultValue: "production",
          helperText:
            "Select whether to use production or sandbox credentials.",
        },
      ],
    },
    {
      title: "Get your Square access token",
      items: [
        {
          kind: "markdown",
          content:
            "In the Square Developer Dashboard, go to your application and find the **Access token** in the Credentials tab. For sandbox, use the Sandbox Access Token.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://connect.squareup.com/v2/merchants/me",
  },
});
